<template>
    <div class="module-itemslist" id="mating-pairs-wrapper">
        <div class="items-wrapper" v-if="items.length && !globalStore.loading">
            <template v-for="(item, key) in items" :key="key">
                <PartListItem :item="item"></PartListItem>
            </template>
        </div>
        <div class="no-results" v-if="!items.length && !globalStore.loading">
            <div class="form__no-results" v-if="!cartStore.noresultSubmitted">
                <form class="no-results__form" @submit.prevent="onSubmitForm">
                    <p>{{ $t('list.noresults.formRequest') }}</p>
                    <InputField
                            :required="true"
                            identifier="email"
                            :label="$t('overlay.form.email')"
                            v-model="cartStore.noresultsForm.email"
                            :value="cartStore.noresultsForm.email"
                    ></InputField>
                    <InputField
                            :required="true"
                            identifier="company"
                            :label="$t('overlay.form.required.company')"
                            v-model="cartStore.noresultsForm.company"
                            :value="cartStore.noresultsForm.company"
                    ></InputField>
                    <InputField
                            :required="true"
                            identifier="zip"
                            :label="$t('overlay.form.required.zip')"
                            v-model="cartStore.noresultsForm.zip"
                            :value="cartStore.noresultsForm.zip"
                    ></InputField>
                    <CountrySearch
                            :required="true"
                            identifier="country"
                            :label="$t('overlay.form.required.country')"
                            @prediction-selected="cartStore.noresultsForm.country = $event"
                    ></CountrySearch>
                    <MultiselectCheckbox
                            :required="true"
                    ></MultiselectCheckbox>
                    <TextareaField
                            :required="false"
                            identifier="text"
                            :label="$t('overlay.form.text')"
                            v-model="cartStore.noresultsForm.text"
                            :value="cartStore.noresultsForm.text"
                    ></TextareaField>
                    <button class="btn -btn-alpha" type="submit">{{ $t('list.noresults.buttonText') }}</button>
                    <div v-html="recaptchaInfo"></div>
                </form>
            </div>
            <div class="content-wrapper" v-if="cartStore.noresultSubmitted">
                <div class="overlay__headline">
                    <span class="heading beta -color-text-alpha" v-if="cartStore.noresultSuccess">{{ $t('overlay.headlineSuccess') }}</span>
                    <span class="heading beta -color-text-alpha" v-else>{{ $t('overlay.headlineError') }}</span>
                </div>
                <div class="content__content">
                    <p v-if="!cartStore.noresultSuccess">{{ $t('overlay.textError') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue'

import { useGlobalStore } from '@/stores'
import { useCartStore } from '@/stores/cart'
import PartListItem from '@/components/PartListItem'
import InputField from '@/components/form/InputField'
import TextareaField from '@/components/form/TextareaField.vue'
import MultiselectCheckbox from '@/components/form/MultiselectCheckbox.vue'
import CountrySearch from '@/components/form/CountrySearch.vue'

const recaptchaInfo = window.app.partnumber_search_extended.recaptcha_info

const globalStore = useGlobalStore()
const cartStore = useCartStore()
const urlParams = new URLSearchParams(window.location.search)
const searchTerm = urlParams.get('searchTerm')
cartStore.noresultsForm.search = searchTerm

function handleMultiselectCheckbox ()
{
    const multiSelect = document.getElementsByClassName('checkbox')
    let flag = true
    let multiselect = []

    for (let i = 0; i < multiSelect.length; i++)
    {
        // if at least one option is checked permit submit action
        if (multiSelect[i].classList.contains('-checked'))
        {
            const span = multiSelect[i].getElementsByTagName('span')[0]
            multiselect.push(span.innerText)
            flag = false
        }
    }

    if (flag)
    {
        document.getElementsByClassName('multiselect-checkbox-form-group')[0].classList.add('-error')
        // show error
        return false
    }
    else
    {
        cartStore.noresultsForm.multiselect = multiselect
        return true
    }
}

function onSubmitForm ()
{
    const submitAllowed = handleMultiselectCheckbox()

    if (submitAllowed)
    {
        cartStore.submitNoresultForm()
    }
}

defineProps({
    items: {
        type: Array,
        default: null
    }
})
</script>

